/** Сравнение сроков «без системы» / «с AI-Tenders» — hero-таблица и SVG в showcase. */

const HERO_ROW_DEFS = [
  {
    label: 'Первичный разбор документации',
    before: '4–8 ч',
    after: '3–5 мин',
    minVisualAfterPct: 18,
    hint: 'Критерии, риски и требования — в структурированном виде',
  },
  {
    label: 'Решение «участвуем / отказываемся»',
    before: '1–2 дня',
    after: '5–10 мин',
    minVisualAfterPct: 22,
    hint: 'Прогноз победы и маржинальность на одном экране',
  },
  {
    label: 'Подготовка к подаче',
    before: '3–5 дней',
    after: '2–3 часа',
    minVisualAfterPct: 36,
    hint: 'Этапы согласования без хаоса в переписке',
  },
]

/** Парсит «4–8 ч», «3–5 мин», «1–2 дня» → { min, max } в минутах. */
export function parseDurationRange(text) {
  const raw = String(text || '').trim().toLowerCase().replace(/\s+/g, ' ')
  const m = raw.match(/^(\d+(?:[.,]\d+)?)\s*[–-]\s*(\d+(?:[.,]\d+)?)\s*(ч|час|часа|часов|мин|минут|день|дня|дней|дн)$/)
  if (!m) return { min: 0, max: 0 }
  const a = parseFloat(m[1].replace(',', '.'))
  const b = parseFloat(m[2].replace(',', '.'))
  const unit = m[3]
  let factor = 1
  if (unit.startsWith('ч')) factor = 60
  else if (unit.startsWith('д')) factor = 24 * 60
  return { min: Math.min(a, b) * factor, max: Math.max(a, b) * factor }
}

function midpointMinutes(range) {
  return (range.min + range.max) / 2
}

export function visualAfterPct(beforeText, afterText, minVisualAfterPct) {
  const before = parseDurationRange(beforeText)
  const after = parseDurationRange(afterText)
  const floor = minVisualAfterPct ?? 24
  if (!before.max || !after.max) return floor
  const linear = Math.round((midpointMinutes(after) / midpointMinutes(before)) * 100)
  return Math.min(100, Math.max(floor, linear))
}

/** Середина диапазонов — для подписи на SVG-графике showcase. */
function speedupMidRatio(beforeText, afterText) {
  const before = parseDurationRange(beforeText)
  const after = parseDurationRange(afterText)
  if (!after.min || !before.max) return 90
  return Math.round(midpointMinutes(before) / midpointMinutes(after))
}

export const HERO_TIME_ROWS = HERO_ROW_DEFS.map((row) => ({
  ...row,
  beforePct: 100,
  visualAfterPct: visualAfterPct(row.before, row.after, row.minVisualAfterPct),
}))

const accent = '#0071e3'
const accentMuted = '#8e8e93'
const chartBase = 268
const maxHours = 8
const scale = 200 / maxHours
const manualHours = 6
const aiHours = 4 / 60
const manualBarHeight = manualHours * scale
const realAiBarHeight = aiHours * scale
const visualAiBarHeight = Math.max(realAiBarHeight, manualBarHeight * 0.28)
const ratioNum = speedupMidRatio('4–8 ч', '3–5 мин')

export const EFFICIENCY_CHART = {
  ariaLabel: 'Сравнение: 4–8 часов разбора вручную и 3–5 минут с AI-Tenders',
  chartTitle: 'Первичный разбор одной закупки',
  ratioLabel: `≈ в ${ratioNum} раз быстрее`,
  captionNote: 'Высота синего столбца увеличена для наглядности; подписи — фактические сроки.',
  yTicks: [
    { label: '8 ч', y: 56 + 4 },
    { label: '4 ч', y: 56 + scale * 4 + 4 },
    { label: '0', y: chartBase + 4 },
  ],
  bars: [
    {
      label: 'Вручную',
      hours: '4–8 ч',
      x: 120,
      w: 120,
      h: manualBarHeight,
      y: chartBase - manualBarHeight,
      cx: 180,
      fill: accentMuted,
    },
    {
      label: 'С AI-Tenders',
      hours: '3–5 мин',
      x: 360,
      w: 120,
      h: visualAiBarHeight,
      y: chartBase - visualAiBarHeight,
      cx: 420,
      fill: accent,
      realH: realAiBarHeight,
      realY: chartBase - realAiBarHeight,
    },
  ],
}
